
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe02 as ObiHydraulicPipe02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-02.js';
 
 
 

 
 export const ObiHydraulicPipe02 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-02',
   elementClass: ObiHydraulicPipe02Element,
   events: {
     
   }
  });
 
 